import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.892 13.401l2.083-2.083a.5.5 0 1 1 .707.707l-2.828 2.829a.498.498 0 0 1-.708 0l-2.828-2.829a.5.5 0 1 1 .707-.707l1.885 1.885A8 8 0 0 0 5.735 7.024l-.661-.771a9 9 0 0 1 15.818 7.149zM4.09 10.797a8 8 0 0 0 14.175 6.179l.661.771a9 9 0 0 1-15.818-7.149l-2.083 2.084a.5.5 0 1 1-.707-.707l2.828-2.829a.5.5 0 0 1 .708 0l2.828 2.829a.5.5 0 0 1-.707.707L4.09 10.797z"
});

var SvgReplacement = function SvgReplacement(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgReplacement;